export default "__VITE_ASSET__507e36c8__"